<template>
    <div class="InterSelect" v-bind:class="{ with_error: error}">
        <div class="InterSelect-label mb-1" v-if="label">
            {{label}}
        </div>
        <multiselect
                ref="royselect"
                :placeholder="placeholder"
                v-model="selected"
                :options="selectOptions"
                :multiple="multiple"
                :searchable="searchable"
                :loading="isLoading"
                label="name"
                track-by="value"
                :taggable="taggable"
                deselectLabel="Remove"
                selectLabel="Select"
                @input="onInput"
                @tag="addTag"
                @open="onOpen"
                @search-change="asyncFind">

            <template slot="singleLabel" slot-scope="{ option }">
                <div :class="'text-' + textAlign" class="text-truncate">
                    <strong v-if="option.value">{{ option.name }}</strong>
                </div>
            </template>

            <template slot="option" slot-scope="props">
                <div class="option__desc text-truncate">
                    {{ props.option.name }}
                    </div>
            </template>

            <template>
                <span slot="noResult">
                Oops! No elements found.
                </span>
            </template>

        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import _ from 'lodash';
    import api from '@/api';

    export default {
        name: "InterSelect",
        components: {Multiselect},
        props: {
            archive: {
               type: Boolean,
               default: false
            },
            label: {
                required: false,
                type: [String, null],
                default: null
            },
            placeholder: {
                required: false,
                type: [String, null],
                default: ''
            },
            multiple: {
                type: [Boolean],
                default: false
            },
            taggable: {
                type: [Boolean],
                default: false
            },
            searchable: {
                type: [Boolean],
                default: true
            },
            error: {
                type: [Boolean],
                default: false
            },
            textAlign: {
                type: [String],
                default: 'left'
            },
            options: {
                type: Array,
                default: () => []
            },
            optionSelected: {
                default: null
            },
            asyncFindAction: {
                type: String
            },

        },
        data() {
            return {
                selected: null,
                focusIn: false,
                selectOptions: [],
                isLoading: false,
            }
        },
        mounted() {

            this.selectOptions = this.options;

            if(this.asyncFindAction && !this.selected) {
                this.getAsyncOptions()
            } else {
                this.setSelectedOption();
            }

        },

        methods: {

            setSelectedOption: function() {
                let target = _.filter(this.selectOptions, item => item.value === this.optionSelected);
                if (target.length !== 0) {
                    this.selected = target[0];
                    this.$emit('input', this.selected.value);
                }
            },
            onInput(input) {

                let value = null;
                if(input) {
                    if(this.multiple) {
                        value = _.map(input, (item) => {
                            return item.value;
                        });
                    } else {
                        value = input.value;
                    }
                }

                this.$emit('input', value)
                this.$emit('onSelected', this.selected);

            },
            onOpen() {
                if(this.asyncFindAction && !this.selected) {
                    this.getAsyncOptions()
                }
            },
            addTag (newTag) {
                const tag = {
                    name: newTag,
                    value: newTag
                };
                this.selectOptions.push(tag);
                this.selected = tag;
                this.$emit('input', this.selected.value);
            },

            getAsyncOptions(query) {

                this.isLoading = true;
                api({url: this.asyncFindAction, data: {
                    selected: this.optionSelected,
                    query: query ? query : '',
                    archive: this.archive
                    }, method: 'POST'})
                    .then(resp => {
                        this.isLoading = false;
                        this.selectOptions = resp.data;
                        if(this.optionSelected) {
                            this.setSelectedOption();
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    })
            },

            asyncFind(query) {
                if(this.asyncFindAction && query.length >= 3) {
                    this.getAsyncOptions(query)
                }
            }
        }
    }
</script>

<style scoped>

</style>
